import React, { Fragment } from 'react'
import { Row } from 'reactstrap'
import { injectIntl } from 'react-intl'
import { Colxx } from '../../../components/common/CustomBootstrap'
import EditorsSummary from './EditorsSummary'


function CreateSummary() {

  return (
    <Fragment>
      <Row>
        <Colxx xl="12" xxl="12" lg="12" className="mb-4">
          <EditorsSummary tool="paraphrase" />
        </Colxx>
      </Row>
    </Fragment>
  )
}
export default injectIntl(CreateSummary)
